<div class="loading__container">
    <div class="spin-wrapper">
        <span class="spinner"></span>
    </div>
    <app-footer [caricamento]="true"></app-footer>
</div>